import axiosClient from './axiosClient';

export const fetchLeaderboard = async () => {
    try {
        const response = await axiosClient.get('/leaderboard');
        if (response.data && response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.errors || 'Failed to fetch leaderboard data');
        }
    } catch (error) {
        throw error;
    }
}; 